import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map } from 'rxjs';

import { LaunchDarklyService } from 'src/app/services/launchdarkly.service';

/**
 * Route guard that allows for blocking routes depending on feature flags.
 * @param flagName Name of flag to check.
 * @param redirectRoute Where to redirect if check fails.
 * @returns CanActivateFn used in router.
 */
export function featureFlagGuard(flagName: string, redirectRoute: string): CanActivateFn {
	return () => {
		const launchDarklyService: LaunchDarklyService = inject(LaunchDarklyService);
		const router: Router = inject(Router);
		return launchDarklyService.launchDarklyFlags$.pipe(map(flags => (flags[flagName] ? true : router.createUrlTree([redirectRoute]))));
	};
}
